// extracted by mini-css-extract-plugin
export var label = "_dh-2";
export var slideContainer = "_dh-0";
export var slider = "_dh-1";